import * as React from 'react';

// Styled
import { OrWrap } from './styled';

export function SeparatorOr(): JSX.Element {
  return <OrWrap>OR</OrWrap>;
}
